import { useQuery } from '@tanstack/react-query';
import { BaseHTTPError } from '@fe-core/errors';
import { getSession } from '@api/queries/session';
import { TSessionDetails } from '@api/io/session.io';
import { useConfigContext } from '@fe-core';

export const QUERY_KEY = 'session-details';

export const useSessionDetails = ({
  enabled,
  sessionId,
}: {
  enabled: boolean;
  sessionId?: string;
}) => {
  const { config } = useConfigContext();
  if (!sessionId) {
    throw new Error('Missing sessionId');
  }

  if (!config.apiUrls.ccapi) {
    throw new Error('Missing API URL');
  }

  return useQuery<TSessionDetails, BaseHTTPError>({
    queryKey: [QUERY_KEY, sessionId],
    queryFn: async () =>
      getSession({ baseUrl: config.apiUrls.ccapi as string, sessionId }),
    retry: false,
    staleTime: 0,
    enabled: enabled,
  });
};
